export const isTransportRoute = (pathname: string): boolean => pathname.includes("/transport/");
